<template>
<el-form-item :label="$t('actions.project.settings.bgmLabel')" class='bgm-setting'>
  <!-- <media-audio-dialog ref='media-audio-dialog' @save='setData' /> -->
  <div v-if='!name'>
    <el-button :plain="true" type='primary' @click='editBgm'>{{$t('actions.project.settings.bgm.submit')}}</el-button>
    <p class='hint'>{{$t('hint.project.edit.bgm')}}</p>
  </div>
  <div class='bgm-player' v-else>
    <el-popover ref="volume-popover" placement="right" trigger="click" width="40" popper-class='vertical'>
      <el-slider vertical height="100px" v-model='volume'></el-slider>
    </el-popover>
    <a class='player-btn' v-on:click="player.pause(); paused = true" v-show='!paused'><i class='ppj-icon-pause'></i></a>
    <a class='player-btn' v-on:click="player.play(); paused = false" v-show='paused'><i class='ppj-icon-play'></i></a>
    <span>{{name}}</span>
    <span class='btn-group'>
        <a class='volume-btn btn' v-popover:volume-popover>音量</a>
        <a class='remove-btn btn' v-on:click="setData()">{{$t('common.buttons.delete')}}</a>
    </span>
    <!-- <a v-on:click.stop="editBgm"><i class='ppj-icon-pencil'></i></a> -->
  </div>
</el-form-item>
</template>

<style lang='scss' scoped>
.bgm-setting {
    .hint {
        line-height: 1;
        margin-bottom: 0;
    }
    .bgm-player {
        padding-right: 80px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        position: relative;

        .player-btn {
            margin-left: 0.5em;
            &:hover {
                color: $font-color-strong;
            }
        }

        .btn-group {
            float: right;
            position: absolute;
            right: 0.5em;

            .btn {
                margin-right: 0.5em;
                color: $color-info;

                &:last-of-type {
                    margin-right: 0;
                }
            }
        }
        &:hover {
            background-color: $color-info-bg;
        }
    }
}
</style>

<script>
// import MediaAudioDialog from '@/components/media/audio.dialog'
export default {
  data() {
    return {
      mediaId: null,
      name: null,
      url: null,
      player: null,
      volume: 100,
      paused: true
    }
  },
  // components: {
  //   'media-audio-dialog': MediaAudioDialog
  // },
  props: ['value'],
  watch: {
    value: function(newValue) {
      this.setData(newValue)
    },
    volume: function(newValue) {
      let vm = this
      if (vm.player) {
        vm.player.volume = newValue * 1.0 / 100
      }
    }
  },
  methods: {
    editBgm() {
      let vm = this
      //   vm.$refs['media-audio-dialog'].open()
      vm.$mediaAudio({
        success: vm.setData
      })
    },
    setData(value = {}) {
      if (!value) return
      let vm = this

      vm.url = value.file_url || value.url || null
      vm.name = value.name || null
      vm.mediaId = value.id || value.url || null
      vm.volume = ((value.volume === undefined || value.volume === null) ? 100 : Math.floor(value.volume * 100))

      if (vm.player) {
        vm.player.pause()
        vm.paused = true
      }

      if (vm.url) {
        if (!vm.player) {
          try {
            vm.player = new Audio()
            vm.player.volume = vm.volume * 1.0 / 100
          } catch (e) {
            console.log(e)
          }
        }
        vm.player.src = vm.url
        vm.paused = true
      }
    },
    save() {
      this.$emit('input', {
        mediaId: this.mediaId,
        name: this.name,
        url: this.url,
        volume: this.volume * 1.0 / 100
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// bgm.card.vue?a7f6738e